import React, { useState, useEffect } from "react";
import UniversalBack from "../../common/mobile/UniversalBack";
import { fetchLogo } from '../../../services/apiService';

function ForgotPassword({ showAlert }){
	const [activeTab, setActiveTab] = useState("email");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [username, setUsername] = useState("");
	const [otp, setOtp] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [error, setError] = useState("");

	const sendOtp = (type) => {
		let data = {};
		if (type === "email") { 
			if(!email) {
				setError("Please enter your email address.");
				return;
			}
			if(!username) {
				setError("Please enter your username.");
				return;
			}

			data = {
				type: type,
				email: email,
				username: username
			};
		}

		if (type === "sms") {
			if(!phone) {
				setError("Please enter your phone number.");
				return;
			}
			if(!username) {
				setError("Please enter your username.");
				return;
			}

			data = {
				type: type,
				phone: phone,
				username: username
			};
		}

		setError("");


		fetch(`${process.env.REACT_APP_API_URL}/api/usr-forgot-password`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify(data)
		}).then(response => {
			if (!response.ok) {
				return response.json().then(errData => {
					const errMsg = errData?.message || "Failed to send OTP. Please try again.";
					throw new Error(errMsg);
				});
			}
			return response.json();
		}).then(data => {
			console.log("Response:", data);
			showAlert("OTP sent successfully. Please check your " + type + ".", 'success');
			setActiveTab('otp');
		}).catch(error => {
			console.error("Error:", error);
			let err = error?.message || "An error occurred while sending the OTP. Please try again.";
			setError(err);
		});
		
	}

	const chnagePassword = () => {

		if(!otp) {
			setError("Please enter the OTP.");
			return;
		}
		if(!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(newPassword)) {
			setError("New Password must contain at least one number, one letter, and 8 characters long.");
			return;
		}
		if(!confirmPassword) {
			setError("Please confirm your new password.");
			return;
		}
		if(newPassword !== confirmPassword) {
			setError("Passwords do not match.");
			return;
		}

		setError("");
		fetch(`${process.env.REACT_APP_API_URL}/api/usr-reset-password`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json"
			},
			body: JSON.stringify({
				otp: otp,
				password: newPassword,
				password_confirmation: confirmPassword,
				username: username
			})
		}).then(response => {
			if (!response.ok) {
				return response.json().then(errData => {
					const errMsg = errData?.message || "Failed to change password. Please try again.";
					throw new Error(errMsg);
				});
			}
			return response.json();
		}).then(data => {
			showAlert("Password changed successfully. Please login with your new password.", 'success');
			setTimeout(() => {
				window.location.href = "/login";
			}, 1500);
		}).catch(error => {
			console.error("Error:", error);
			setError(error?.message || "An error occurred while changing the password. Please try again.");
		});
	}

     const [logo, setLogo] = useState([]);
         useEffect(() => {
             fetchLogo()
                 .then((data) => setLogo(data[0]?.logo || data?.logo || ''))
                 .catch((error) => console.error("Error fetching logo:", error));
         }, []);
    return(
        
        <div  className="wrap ">
            <header  id="header" mcdneuaexpose data-neua="{&quot;event_name&quot;:&quot;view&quot;,&quot;event_type&quot;:&quot;exposure&quot;,&quot;event_page&quot;:&quot;Online Cricket Betting in Bangladesh | JeetBuzz&quot;,&quot;event_payload&quot;:{&quot;loc&quot;:&quot;header&quot;,&quot;version&quot;:&quot;v1&quot;}}" className="ng-star-inserted register">
  <div  className="header-left-btn-group">
    <UniversalBack/>
    
    <div  className="menu-btn">
      <ul >
        <li  />
        <li  />
        <li  />
      </ul>
    </div>
  </div>
  <div  className="header-title ng-star-inserted">Forgot password?</div>
  
</header>

  <div className="content  fixed-tab register-content" style={{}}>
    <div className=" ng-trigger ng-trigger-routeLayoutPageAni">
        <div className="tab-btn-section ">
            <div className="tab-btn tab-btn-page ng-star-inserted">
            <div className="line" style={{ width: 'calc(50%)', transform: activeTab === "email" ? 'translate(0, 0)' : 'translate(100%, 0)' }} />
              <div className={`btn ${activeTab === "email" ? "active" : ""}`} onClick={() => setActiveTab("email")}>
                <div  className="text">
                  Email
                
                </div>
              </div>
              <div className={`btn ${activeTab === "sms" ? "active" : ""}`} onClick={() => setActiveTab("sms")} >
                <div className="text">
                  SMS
                </div>
              </div>
             
            </div>
          
        </div>
        <div className=" ng-trigger ng-trigger-tabPageTriggerAni">
            <div  className="tab-content tab-content-page forgetpassword ng-star-inserted">
            <div className="logo-box ng-star-inserted" style={{ backgroundImage: `url('${process.env.REACT_APP_API_URL}/storage/${logo}')` }} />

				<div className="error-message" style={{ color: 'red', fontSize: '16px', marginTop: '10px', textAlign: 'center' }}>
					{error && <span>{error}</span>}
				</div>
				
				{activeTab === "email" && (
					<form noValidate className="inner-box">
						<div className="member-box radius">
							<div className="inputbox-wrapper">
								<div className="inputbox">
									<label >Username</label>
									<input removewhitespace type="text" className="input" placeholder="Username" onChange={(e) => setUsername(e.target.value)} value={username} />
									<input className="clear" />
								</div>
								<div style={{ display: 'grid', lineHeight: '20px' }} className="ng-star-inserted">{/**/}</div>
		
							</div>
							<div className="inputbox-wrapper">
								<div className="inputbox">
									<label >E-mail</label><input type="text" className="input" placeholder="Input valid email" onChange={(e) => setEmail(e.target.value)} value={email} />
									<input className="clear" />
								</div>
								<div style={{ display: 'grid', lineHeight: '20px' }} className="ng-star-inserted">{/**/}</div>
		
							</div>
	
						</div>
	
						<div className="button"><a href="javascript:{};" onClick={() => sendOtp("email")}>Send OTP</a></div>
					</form>
				)}
				
				
			    { activeTab === "sms" && (
                <form  noValidate className="inner-box" style={{height: 'auto'}}>
                <div  className="member-box radius">
                  <div  className="inputbox-wrapper">
                    <div  className="inputbox inputbox error">
                      <label >Username</label><input  removewhitespace type="text" className="input" placeholder="Username" onChange={(e) => setUsername(e.target.value)} value={username}  />
                      <input  className="clear" />
                    </div>
                    <div  style={{display: 'grid', lineHeight: '20px'}} className="ng-star-inserted">{/**/}</div>
                    
                  </div>
                  <div  className="inputbox-wrapper">
                    <div  className="inputbox phone-number">
                      <label >Phone Number</label>
                      <div  className="input-wrap phone-wrap">
                        <div  className="phone-area-code">
                          <div  className="lang-select">
                            <button  value className="btn-select">
                              <li >
                                <img  value="BD" alt="BD" src="https://img.j189eb.com/jb/h5/assets/images/flag/BD.png?v=1734504295963&source=mcdsrc" loading="lazy" />
                                <span >+880</span>
                              </li>
                            </button>
                            <div  className="phone-code-list-group" style={{display: 'none'}}>
                              <ul  className="phone-code-list">
                                <li  className="ng-star-inserted">
                                  <img  value="BD" alt="BD" src="https://img.j189eb.com/jb/h5/assets/images/flag/BD.png?v=1734504295963&source=mcdsrc" loading="lazy" />
                                  <span >+880</span>
                                </li>
                                <li  className="ng-star-inserted">
                                  <img  value="IN" alt="IN" src="https://img.j189eb.com/jb/h5/assets/images/flag/IN.png?v=1734504295963&source=mcdsrc" loading="lazy" />
                                  <span >+91</span>
                                </li>
                                <li  className="ng-star-inserted">
                                  <img  value="PK" alt="PK" src="https://img.j189eb.com/jb/h5/assets/images/flag/PK.png?v=1734504295963&source=mcdsrc" loading="lazy" />
                                  <span >+92</span>
                                </li>
                               
                              </ul>
                            </div>
                          </div>
                        </div>
                        <input  type="number" name="phone" className="input" placeholder="Phone" onChange={(e) => setPhone(e.target.value)} value={phone} /><input  className="clear" />
                      </div>
                    </div>
                    <div  style={{display: 'grid', lineHeight: '20px'}} className="ng-star-inserted">{/**/}</div>
                   
                  </div>
                  <div  className="inputbox-wrapper ng-star-inserted" style={{}}>
                    <div  className="inputbox turnstile">
                     
                        <div id="turnstile-container">
                          <div><input type="hidden" name="cf-turnstile-response" id="cf-chl-widget-7b6no_response" /></div>
                        </div>
                      
                    </div>
                  </div>
                  
                </div>
                
                <div  className="button"><a href="javascript:{};" onClick={() => sendOtp("sms")}>Send OTP</a></div>
				</form>
				)}
							
				{ activeTab === "otp" && (
                <form noValidate className="inner-box" style={{height: 'auto'}}>
					<div className="member-box radius">
						<div className="inputbox-wrapper">
							<div  className="inputbox inputbox error">
							<label>OTP</label><input removewhitespace type="text" className="input" placeholder="Enter 6 Digit OTP" onChange={(e) => setOtp(e.target.value)} />
							<input  className="clear" />
							</div>
							<div style={{display: 'grid', lineHeight: '20px'}} className="ng-star-inserted">{/**/}</div>
						</div>
					</div>
					
					<div className="member-box radius">
						<div className="inputbox-wrapper">
							<div  className="inputbox inputbox error">
							<label>New Password</label><input removewhitespace type="password" className="input" placeholder="Enter New Password" onChange={(e) => setNewPassword(e.target.value)}  />
							<input className="clear" />
							</div>
							<div style={{display: 'grid', lineHeight: '20px'}} className="ng-star-inserted">{/**/}</div>
						</div>
					</div>
					
					<div className="member-box radius">
						<div className="inputbox-wrapper">
							<div  className="inputbox inputbox error">
							<label>Confirm Password</label><input removewhitespace type="password" className="input" placeholder="Confirm Password" onChange={(e) => setConfirmPassword(e.target.value)}  />
							<input className="clear" />
							</div>
							<div style={{display: 'grid', lineHeight: '20px'}} className="ng-star-inserted">{/**/}</div>
						</div>
					</div>
					
					<div className="button">
						<a href="javascript:{};" onClick={() => { chnagePassword() }}>Confirm</a>
					</div>
				</form>
				)}
            </div>
          
        </div>
     
     
    </div>
  </div>

</div>

    );

}
export default ForgotPassword;